export interface IncentiveTravelFile {
    id?: string; // Para archivos existentes (puede ser fileId del servidor)
    fileId?: string; // ID del archivo en el servidor
    incentiveTravelId?: string;
    fileType: number;
    fileName: string;
    externalUrl: string;
    fileBase64: string;
    blobUrl?: string; // URL directa al archivo en Azure Blob Storage
    uploadedAt?: string; // Fecha de subida
    isExisting?: boolean; // Para distinguir entre archivos existentes y nuevos
    isModified?: boolean; // Para marcar archivos que han sido editados
}

// Interface para archivos nuevos según swagger
export interface NewIncentiveTravelFile {
    incentiveTravelId: string;
    fileType: number;
    fileName: string;
    externalUrl: string;
    fileBase64: string;
}

// Interface para datos de edición según swagger
export interface IncentiveTravelUpdateData {
    title: string;
    description: string;
    destination: string;
    generalConditions: string;
    isActive: boolean;
    objectivePoints: number;
    startDate: string; // ISO string
    endDate: string; // ISO string
    filesIdToRemove: string[]; // IDs de archivos a eliminar
    newFilesDto: NewIncentiveTravelFile[]; // Archivos nuevos
}

export interface IncentiveTravel {
    id?: number;
    title: string;
    centerGroupId?: number; // Autocompletado desde el back
    description: string;
    destination: string;
    generalConditions: string;
    isActive: boolean;
    objectivePoints: number;
    pointsEarned: number;
    startDate: Date;
    endDate: Date;
    filesDto: IncentiveTravelFile[];
    isObjectiveCompleted?: boolean; // Nuevo campo para indicar si se completó el objetivo
}

export interface IncentiveTravelFormData {
    title: string;
    description: string;
    destination: string;
    generalConditions: string;
    isActive: boolean;
    objectivePoints: number;
    pointsEarned: number;
    startDate: Date;
    endDate: Date;
    filesDto: IncentiveTravelFile[];
}

export enum TravelStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    COMPLETED = 'completed'
}

export enum FileType {
    IMAGE = 0,
    DOCUMENT = 1,
    VIDEO = 2
}

export interface IncentiveTravelProgress {
    totalTravels: number;
    activeTravels: number;
    completedTravels: number;
    totalPointsObjective: number;
    totalPointsEarned: number;
    progressPercentage: number;
}